import { Colors, Services } from '@sigma-frontend-libs/commons'

import { icons } from '@/utils'

import sticker from '@/components/sticker'
import actions from '@/components/templates/service/item/actions'
import date from '@/components/templates/service/item/date'
import owner from '@/components/templates/service/item/owner'

const missingSignMethodIcon = icons.help_outline
const missingSignMethodKeys = {
  null: 'null',
  undefined: 'undefined'
}

const signMethodIcons = {
  original: icons.verified,
  'edo-diadok': icons.insert_drive_file,
  'edo-sbis': icons.insert_drive_file,
  copy: icons.file_copy,
  [missingSignMethodKeys.null]: missingSignMethodIcon,
  [missingSignMethodKeys.undefined]: missingSignMethodIcon
}

function getSignMethodKey(signMethod) {
  if (signMethod === null) {
    return missingSignMethodKeys.null
  }
  if (signMethod === undefined) {
    return missingSignMethodKeys.undefined
  }

  return signMethod
}

function renderTitle(h) {
  let label = this.getTranslate(`${Services.contracts}.labels.title`)
  if (this.viewport.breakpoint.xs) {
    label = this.value.Owner.username
  }

  return h(
    sticker,
    {
      props: {
        value: this.value,
        label,
        service: Services.contracts
      }
    }
  )
}
function renderSignMethod(h) {
  if (this.viewport.breakpoint.xs) {
    return
  }

  const signMethodKey = getSignMethodKey(this.value.signMethod)
  if (!signMethodKey) {
    return
  }

  return h(
    sticker,
    {
      props: {
        value: this.getTranslate(`${Services.contracts}.signMethods.${signMethodKey}`),
        label: this.getTranslate(`${Services.contracts}.labels.signMethod`),
        color: Colors.grey,
        icon: signMethodIcons[signMethodKey]
      }
    }
  )
}
function renderInfo(h) {
  return h(
    'div',
    {
      class: `${Services.contracts}-item__info`,
      style: {
      }
    },
    [
      renderTitle.call(this, h),
      renderSignMethod.call(this, h)
    ]
  )
}

function renderOwner(h) {
  if (this.value.Owner) {
    return h(
      owner,
      {
        props: {
          value: this.value
        }
      }
    )
  }
}
function renderRequisite(h) {
  if (this.value.Requisite) {
    return h(
      sticker,
      {
        props: {
          value: this.value.Requisite,
          label: this.getTranslate(`${Services.contracts}.labels.requisite`),
          icon: icons.class,
          color: Colors.grey,
          service: Services.requisites
        }
      }
    )
  }
}
function renderCompany(h) {
  if (this.value.Company) {
    return h(
      sticker,
      {
        props: {
          value: this.value.Company,
          label: this.getTranslate(`${Services.contracts}.labels.company`),
          icon: icons.class,
          color: Colors.grey,
          service: Services.companies
        }
      }
    )
  }
}
function renderDetails(h) {
  if (this.viewport.size.width > 1280) {
    return h(
      'div',
      {
        class: `${Services.contracts}-item__details`
      },
      [
        renderOwner.call(this, h),
        renderRequisite.call(this, h),
        renderCompany.call(this, h)
      ]
    )
  }
}

function renderActions(h) {
  return h(
    actions,
    {
      props: {
        value: this.value,
        service: Services.contracts
      }
    }
  )
}

function renderCreatedAt(h) {
  return h(
    date,
    {
      props: {
        value: this.value
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: `${Services.contracts}-item service-template-item`
    },
    [
      renderInfo.call(this, h),
      renderDetails.call(this, h),
      renderActions.call(this, h),
      renderCreatedAt.call(this, h)
    ]
  )
}
